import React from "react";
import PropTypes from "prop-types";
import styles from "./Checkbox.module.css";

/**
 * Interactive component. An input checkbox that allows a user to toggle options that appear when a dropdown is open.
 */
export function Checkbox({ value, isChecked, setCheckedList }) {
  return (
    <div className={styles.container}>
      <label htmlFor={value}>
        <input
          type="checkbox"
          id={value} // Use unique id for each input
          name={value}
          checked={isChecked}
          onChange={setCheckedList}
          className={styles.checkbox}
        />
        <span className={styles.checkmark}></span>
        <span className={styles.label}>{value}</span>
      </label>
    </div>
  );
}

Checkbox.propTypes = {
  /**
   * The value of the checkbox.
   */
  value: PropTypes.string,
  /**
   * Boolean that determines whether the checkbox is checked or not.
   */
  isChecked: PropTypes.bool,
  /**
   * Function that fires when the checkbox is clicked.
   * Takes the value as a parameter.
   */
  setCheckedList: PropTypes.func,
};
